import { createFileRoute } from '@tanstack/react-router';
import { CustomersAndPrices } from '../../../features/sales-invoicing/CustomersAndPrices';

/** Owned by G23. Customers + customer prices registers + create/edit. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/customers')({
  component: CustomersAndPrices,
});
